export default __webpack_public_path__ + "static/category-brochure-desktop-08f2bc2a02cccad7cca5dbce91b5346c.png";